import Grid from '@mui/material/Grid';
import VariantPathoText from './VariantPathoText';
import DiseaseButtonGroup from './DiseaseButtonGroup';
import SectionStructure from '../../../../../components/Section/SectionStructure';
import CardiovascularCard from './VariantPatho/CardiovascularCard'
import AuditoryCard from './VariantPatho/AuditoryCard';
import ImmuneCard from './VariantPatho/ImmuneCard';
import MetabolicCard from './VariantPatho/MetabolicCard';
import NervousCard from './VariantPatho/NervousCard';
import MuscoCard from './VariantPatho/MuscoCard';
import PsycoCard from './VariantPatho/PsycoCard';
import DigestCard from './VariantPatho/DigestCard';
import HematologicCard from './VariantPatho/HematologicCard'
import EndocrineCard from './VariantPatho/EndocrineCard';
import HeredityCard from './VariantPatho/HeredityCard';

export default function SectionVariantPatho() {

    
    return (

    <SectionStructure
    
            sectiontext=    { <VariantPathoText /> }
            sectiondiagroup=    { <DiseaseButtonGroup />} 

            sectioncards=  {<>

                <Grid container>
                        <Grid > <AuditoryCard />  </Grid>
                        <Grid > <PsycoCard />  </Grid>
                        <Grid > <NervousCard />  </Grid>  
                        <Grid > <HematologicCard />  </Grid>
                        <Grid > <ImmuneCard />  </Grid>
                        <Grid > <CardiovascularCard />  </Grid>
                        <Grid > <DigestCard />  </Grid> 
                        <Grid > <EndocrineCard />  </Grid>
                        <Grid > <MuscoCard />  </Grid>
                        <Grid > <MetabolicCard />  </Grid>
                        <Grid > <HeredityCard />  </Grid>
            </Grid>
        </>}
    />
)
}